import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfServicesWos
export const getBillOfServicesWos = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services-wo`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-services-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET a single billOfServicesWo
export const getBillOfServicesWoById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-services-wo/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-services-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// CREATE a new billOfServicesWo
export const createBillOfServicesWo = async (billOfServicesWoData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/bill-of-services-wo`,
      billOfServicesWoData,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating bill-of-services-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// UPDATE an existing billOfServicesWo
export const updateBillOfServicesWo = async (id, billOfServicesWoData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/bill-of-services-wo/${id}`,
      billOfServicesWoData,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating bill-of-services-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// DELETE a billOfServicesWo
export const deleteBillOfServicesWo = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/bill-of-services-wo/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting bill-of-services-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET billOfServicesWos by workOrderId
export const getBillOfServicesWosByWorkOrderId = async (workOrderId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services-wo`, {
      params: { workOrderId },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-services-wo by WO:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET billOfServicesWos by many workOrderIds
export const getBillOfServicesWosByWorkOrderIds = async (workOrderIds = []) => {
  if (!workOrderIds.length) {
    return [];
  }

  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-services-wo/by-work-order-ids`,
      {
        params: { workOrderIds: workOrderIds.join(",") },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-services-wo by WO IDs:",
      error.response?.data || error,
    );
    throw error;
  }
};
